/**
 * Created by Ivan on 24.05.2025
 */

const IceTutorial = function () {
    return new TutorialScenario(IceTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(IceTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(IceTutorial.NAME);
            Game.currentGame.hand.setCards(IceTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(IceTutorial.NAME)
    });
};

IceTutorial.NAME = "ice";
IceTutorial.CONFIG = {
    importantCards: [IceOnCard],
    handValues: ["9"],
    filter: [IceOnCard],
    force: "IceTutorialMessage"
};
